import axios from 'axios'
import store from '@/state/store'

let _axiosBackendApi = null;
let _axiosAuthBackendApi = null;
let _axiosBackendMubinApi = null;

export function initAxiosBackend(config = {}) {
    _axiosBackendApi = axios.create({
        baseURL: config.baseURLApi,
        headers: {
            'accept': 'application/json',
        }
    })

    _axiosBackendMubinApi = axios.create({
        baseURL: config.baseURLMubinApi,
        headers: {
            'accept': 'application/json',
        }
    })

    _axiosAuthBackendApi = _axiosBackendApi

}

export function  getAxiosBackendApi() {
    return _axiosBackendApi
}

export function  getAxiosBackendMubinApi() {
    return _axiosBackendMubinApi
}

export function  getAuthAxiosBackendApi() {
    _axiosAuthBackendApi.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters['auth/getToken']
    return _axiosAuthBackendApi
}